import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"
import { Provider } from "react-redux"
import store from "redux/store"

import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/css/animate.min.css"
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0"
import "./assets/css/demo.css"
import "./assets/css/datatable.css"
import "@fortawesome/fontawesome-free/css/all.min.css"
import 'assets/scss/styles.scss';
import "./assets/css/login.css"
import "react-toastify/dist/ReactToastify.css"

import AdminLayout from "layouts/Admin.js"
import Login from "views/Login.js"
import Logout from "views/Logout.js"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <>
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/admin' render={(props) => <AdminLayout {...props} />} />
          <Redirect from='/' to='/admin/dashboard' />
        </Switch>
      </BrowserRouter>
    </Provider>
  </>
)
